import { render, staticRenderFns } from "./cjcgd.vue?vue&type=template&id=ddad7764"
import script from "./cjcgd.vue?vue&type=script&lang=js"
export * from "./cjcgd.vue?vue&type=script&lang=js"
import style0 from "./cjcgd.vue?vue&type=style&index=0&id=ddad7764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports